export default "__VITE_ASSET__7f41851b__"